import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ExcelService {
  constructor(private http: HttpClient) {}

  //SST -- INICIO
 

  descargarSst(query: any) {
    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "requirementDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "startDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "sort") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "programmerId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "supplierId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "statuses") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    let headers = new HttpHeaders();

    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(`${environment.apiUrl}/solicitudes/reporte?${queryBuid}`, {
        headers: headers,
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  descargarTiempoSst(query: any = []) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "startDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "programmerId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    return this.http
      .get(`${environment.apiUrl}/solicitudes/reporte/tiempo/excel?${queryBuid}`, {
        headers: headers,
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  descargarSstTiempoProgramadores(query: any) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(
        `${environment.apiUrl}/solicitudes/reporte/tiempo/programadores/excel`,
        {
          headers: headers,
          responseType: "blob",
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  //SST - FIN

  //SSTA - INICIO

  descargarSsta(query: any, redirectQuery: any[]) {
    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "programmingDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "startProgrammingDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endProgrammingDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "expressService") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "statuses") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "requestId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "assignedRequestId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "sort") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "transporterId" && redirectQuery.length < 1) {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    redirectQuery.forEach((q) => {
      if (q.col == "programmerName") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + encodeURIComponent(q.value) + "&";
        }
      }
      if (q.col == "mayorA") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "sinFinalizar") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "startAssignedDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endAssignedDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    })

    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(`${environment.apiUrl}/solicitudes-asignadas/reporte?${queryBuid}`, {
        headers: headers,
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  descargarSstaRechazadoByTransportista(query: any = []) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "startDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "transporterId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    return this.http
      .get(
        `${environment.apiUrl}/solicitudes-asignadas/reporte/rechazado/transportistas/excel?${queryBuid}`,
        {
          headers: headers,
          responseType: "blob",
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  descargarSstaTiempoTransportista(query: any) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(
        `${environment.apiUrl}/solicitudes-asignadas/reporte/tiempo/transportistas/excel`,
        {
          headers: headers,
          responseType: "blob",
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  descargarTiempoSsta(query: any) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "startDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "transporterId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    return this.http
      .get(
        `${environment.apiUrl}/solicitudes-asignadas/reporte/tiempo/excel?${queryBuid}`,
        {
          headers: headers,
          responseType: "blob",
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  downloadProgramadoresTableroSstFinishedSsta(query: any) {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "startDateSst") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "yyyy-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + "startDate" + "=" + q.value + "&";
        }
      }
      if (q.col == "endDateSst") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "yyyy-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + "endDate" + "=" + q.value + "&";
        }
      }
      if (q.col == "programmerIds") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "transporterIdSst") {
        if (q.value) {
          queryBuid = queryBuid + "transporterIds" + "=" + q.value + "&";
        }
      }
    });

    return this.http
      .get(
        `${environment.apiUrl}/solicitudes-asignadas/reporte/finalizada/excel?${queryBuid}`,
        {
          headers: headers,
          responseType: "blob",
        }
      )
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  descargarTiempoPromedioPorProgramadorHastaAsignacionPorTransportista(query:any){
    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "startDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "programmerId") {
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
    });

    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(`${environment.apiUrl}/solicitudes-asignadas/reporte/tiempo/programadores/excel?${queryBuid}`, {
        headers: headers,
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  descargarSstFinishedSsta(query:any){
    let queryBuid = "";
    query.forEach((q) => {
      if (q.col == "startDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      if (q.col == "endDate") {
        var datePipe = new DatePipe("en-US");
        q.value = datePipe.transform(q.value, "YYYY-MM-dd");
        if (q.value) {
          queryBuid = queryBuid + q.col + "=" + q.value + "&";
        }
      }
      // if (q.col == "programmerId") {
      //   if (q.value) {
      //     queryBuid = queryBuid + q.col + "=" + q.value + "&";
      //   }
      // }
    });

    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.http
      .get(`${environment.apiUrl}/solicitudes-asignadas/reporte/tiempo/finalizado/excel?${queryBuid}`, {
        headers: headers,
        responseType: "blob",
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
